import { QuestionnaireResponse } from "@medplum/fhirtypes";

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "..";

interface QuestionnaireResponseState {
  questionnaireResponses: Record<string, QuestionnaireResponse | undefined>;
}

const initialState: QuestionnaireResponseState = {
  questionnaireResponses: {},
};

export const questionnaireResponseSlice = createSlice({
  name: "questionnaireResponses",
  initialState,
  reducers: {
    setPostpartumEncounterQuestionnaireResponses: (
      state,
      action: PayloadAction<Record<string, QuestionnaireResponse | undefined>>,
    ) => {
      state.questionnaireResponses = action.payload;
    },
    updatePostpartumEncounterQuestionnaireResponse: (
      state,
      action: PayloadAction<{
        questionnaireName: string;
        questionnaireResponse: QuestionnaireResponse;
      }>,
    ) => {
      state.questionnaireResponses[action.payload.questionnaireName] =
        action.payload.questionnaireResponse;
    },
  },
});

export const {
  setPostpartumEncounterQuestionnaireResponses,
  updatePostpartumEncounterQuestionnaireResponse,
} = questionnaireResponseSlice.actions;

// Selectors
export const selectAllPostpartumEncounterQuestionnaireResponses = (state: RootState) =>
  state.postpartumEncounter.questionnaireResponses;

export const selectPostpartumEncounterQuestionnaireResponseByQuestionnaireName = (
  state: RootState,
  questionnaireName: string,
) => state.postpartumEncounter.questionnaireResponses[questionnaireName];

export default questionnaireResponseSlice.reducer;
